import jexl from 'jexl';

import { StringType } from '../../../../App/types';
import { DataObject, DataObjectValueType } from '../../api';

export const map = (
  items: DataObjectValueType[],
  expression: StringType,
  variables: DataObject = {},
): DataObjectValueType[] | null => {
  if (!Array.isArray(items) || !expression) {
    return null;
  }

  const projections: DataObjectValueType[] = [];
  for (const item of items) {
    const context = { ...variables, it: item };
    const result = jexl.evalSync(expression, context);
    projections.push(result);
  }

  return projections;
};
